import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Container, Grid, Typography, Link, Divider } from '@mui/material';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        py: 4,
        bgcolor: 'primary.main',
        color: 'white',
        mt: 'auto',
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" gutterBottom>
              Hajj Packages
            </Typography>
            <Typography variant="body2">
              Trouvez le forfait Hajj idéal parmi les meilleures agences de voyage.
            </Typography>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" gutterBottom>
              Liens utiles
            </Typography>
            <Link component={RouterLink} to="/" color="inherit" display="block" sx={{ mb: 1 }}>
              Accueil
            </Link>
            <Link component={RouterLink} to="/recherche" color="inherit" display="block" sx={{ mb: 1 }}>
              Recherche avancée
            </Link>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" gutterBottom>
              Contact
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              Email: contact@hajj-packages.com
            </Typography>
            <Typography variant="body2">
              Téléphone: +33 1 23 45 67 89
            </Typography>
          </Grid>
        </Grid>
        <Divider sx={{ my: 3, bgcolor: 'rgba(255, 255, 255, 0.2)' }} />
        <Typography variant="body2" align="center">
          © {new Date().getFullYear()} Hajj Packages. Tous droits réservés.
        </Typography>
      </Container>
    </Box>
  );
};
export default Footer;